import React from 'react';
import {actions} from 'react-redux-form';
import {toast} from 'react-toastify';
import irelandApi from '../irelandApi';
import store from '../store';
import ToastMessage from '../components/common/toast-message';

export const getCurrentUser = () => (dispatch) => {
  dispatch({type: 'GET_CURRENT_USER_PENDING', payload: []});
  return irelandApi.get('/api/current_user')
    .then((response) => {
      dispatch({type: 'GET_CURRENT_USER_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_CURRENT_USER_REJECTED', payLoad: error.data});

      Promise.reject(error);
    });
};

export const getMyProfile = (action = 'GET_PROFILE') => (dispatch) => {
  dispatch({type: `${action}_PENDING`, payload: []});
  return irelandApi.get('/api/users/my_profile')
    .then((response) => {
      const { attributes } = response.data.data;
      const data = {
        personal_address_1: attributes['personal-address-1'] || undefined,
        personal_address_2: attributes['personal-address-2'] || undefined,
        personal_address_3: attributes['personal-address-3'] || undefined,
        personal_address_4: attributes['personal-address-4'] || undefined,
        personal_eircode: attributes['personal-eircode'] || undefined,
        comms_email: attributes['comms-email'] || false,
        comms_mobile: attributes['comms-mobile'] || false,
        email: attributes.email || undefined,
        mobile: attributes.mobile || undefined,
        should_opt_in: attributes['should-opt-in'] || false,
        marketing_accepted: (attributes['marketing-accepted'] || false).toString(),
        has_ignite_gold_outlet: attributes['has-ignite-gold-outlet']
      };

      store.dispatch(actions.load('deep.my_profile', data));

      dispatch({
        type: `${action}_FULFILLED`,
        payLoad: response.data
      });

      dispatch({ type: 'TOGGLE_PRIVACY_MODAL', payLoad: !attributes['privacy-policy-accepted'] });
      dispatch({ type: 'TOGGLE_MARKETING_MODAL', payLoad: attributes['marketing-accepted'] == null });

      dispatch({
        type: 'GET_UNREAD_MESSAGE_COUNT',
        payLoad: {
          unread_messages: response.data.meta['unread-messages']
        }
      });

      if (data.should_opt_in) {
        dispatch({ type: 'TOGGLE_PERSONAL_REWARDS_SETTINGS_DIALOG', payLoad: true });
      }
    })
    .catch((error) => {
      // Added because of #1153. Received the error below when PPC popup is shown.
      // The error comes from react-bootstrap's Modal.
      if (!(error instanceof TypeError &&
        (error.message === "Cannot read property 'window' of null" || error.message === 'node is null'))) {
        dispatch({ type: `${action}__REJECTED`, payLoad: error.data });
        Promise.reject(error);
      }
    });
};

export const getAdminMyProfile = (action = 'GET_PROFILE') => (dispatch) => {
  dispatch({type: `${action}_PENDING`, payload: []});
  return irelandApi.get('/api/admin/users/my_profile')
    .then((response) => {
      const {attributes} = response.data.data;

      const data = {
        title: attributes.title || undefined,
        first_name: attributes['first-name'] || undefined,
        last_name: attributes['last-name'] || undefined,
        comms_email: attributes['comms-email'] || false,
        comms_mobile: attributes['comms-mobile'] || false,
        email: attributes.email || undefined,
        mobile: attributes.mobile || undefined,
      };
      store.dispatch(actions.load('deep.admin_my_profile', data));
      dispatch({type: `${action}_FULFILLED`, payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: `${action}__REJECTED`, payLoad: error.data});
    });
};

export const saveMyProfile = (payLoad) => {
  const formData = new FormData();

  Object.keys(payLoad).forEach((key) => {
    if (payLoad[key] === undefined) {
      formData.append(`my_profile[${key}]`, '');
    } else {
      formData.append(`my_profile[${key}]`, payLoad[key]);
    }
  });

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };
  return irelandApi.patch('/api/users/my_profile', formData, config)
    .then(() => {
      store.dispatch(actions.resetValidity('deep.my_profile'));
      toast.success(<ToastMessage iconStyle="success" message="Profile saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save"/>);
      store.dispatch(actions.resetValidity('deep.my_profile'));
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });
};

export const saveAdminMyProfile = payLoad => irelandApi.patch('/api/admin/users/my_profile', {my_profile: payLoad})
  .then(() => {
    store.dispatch(actions.resetValidity('deep.admin_my_profile'));
    toast.success(<ToastMessage iconStyle="success" message="Profile saved successfully"/>);
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during save"/>);
    store.dispatch(actions.resetValidity('deep.admin_my_profile'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const closeAccount = () =>
  irelandApi.delete('/api/users')
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Account suspended, redirecting to login..."/>);
      store.dispatch({type: 'DELETE_ACCOUNT_SUCCESS'});
    })
    .catch((error) => {
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });
export const acceptPrivacy = () => dispatch => irelandApi.patch('/api/users/accept_privacy_policy')
  .then(() => {
    toast.success(<ToastMessage iconStyle="success" message="You have accepted our privacy policy"/>);
    dispatch({type: 'TOGGLE_PRIVACY_MODAL', payLoad: false});
    window.location.reload(false);
  })
  .catch((error) => {
    // Added because of #1229. Received the error below when PPC popup is shown.
    // The error comes from react-bootstrap's Modal.
    if (!(error instanceof TypeError && error.message === "Cannot read property 'window' of null")) {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred."/>);
      Promise.reject(error);
    }
  });

export const acceptMarketing = (payLoad, dispatch) => irelandApi.patch('/api/users/marketing_consent', {marketing_consent: {...payLoad}})
  .then(() => {
    toast.success(<ToastMessage iconStyle="success" message="Your marketing preferences has been saved"/>);
    dispatch({type: 'TOGGLE_MARKETING_MODAL', payLoad: false});
  })
  .catch((error) => {
    if (!(error instanceof TypeError && error.message === "Cannot read property 'window' of null")) {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred."/>);
      Promise.reject(error);
    }
  });



// WEBPACK FOOTER //
// ./src/actions/user.js